/**
 * Company: SPHMedia
 * Description: [Ads container]
 */

import { ReactElement, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

type AdsContainerProps = {
  children: ReactNode;
  className?: string;
};

/**
 * AdsContainer
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function AdsContainer({
  children,
  className,
}: AdsContainerProps): ReactElement {
  return (
    <div
      data-testid="ads-container"
      className={twMerge("w-full bg-white-200", className)}
    >
      {children}
    </div>
  );
}
